
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export const EmptyState: React.FC = () => {
  return (
    <Card className="border-dashed mt-4">
      <CardContent className="pt-6 text-center text-muted-foreground">
        No creative insights available for this content
      </CardContent>
    </Card>
  );
};
